module.exports = __webpack_public_path__ + "img/10.acf1d6c5.png";